/**
 * Header Section Mock Data
 * Contains dummy data for compliance score and last sync date
 * This data will be replaced with real API responses when backend is ready
 */

const HEADER_MOCK_DATA = {
  complianceScore: 60,
  lastSyncDate: 'Jan 12, 2026 1:24 PM',
};

export default HEADER_MOCK_DATA;
